<template>
  <div class="actual-charge-sum-by-currency">
    <span style="color:deepskyblue;cursor:pointer;padding-left: 5px;" @click="toggle">
      {{ $t('CargoMsg.Cargo_AmountToDetail') }}
      <i :class="showPop?'el-icon-caret-top':'el-icon-caret-bottom'" />
    </span>
    <cargo-ag-grid
      v-show="showPop"
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 300px;height: 155px;position: absolute;bottom: 50px;right: 0;"
    />
  </div>
</template>

<script>
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'ActualChargeSumByCurrency',
  props: {
    dataProvider: { type: Array, default: () => { return [] } } // 需要统计的数据源
  },
  data() {
    return {
      showPop: false,
      gridOptions: {},
      columnDefs: [],
      rowData: []
    }
  },
  watch: {
    dataProvider() {
      if (this.showPop) {
        this.refreshSum()
      }
    }
  },
  created() {
    if (this.showPop) {
      this.refreshSum()
    }
  },
  methods: {
    toggle() {
      if (this.showPop) {
        this.showPop = false
      } else {
        this.refreshSum()
        this.showPop = true
      }
    },
    refreshSum() {
      this.columnDefs = []
      this.rowData = []
      if (this.dataProvider.length > 0) {
        const currencySet = new Set()
        const arCurrencyMap = new Map()
        const apCurrencyMap = new Map()
        const arRealCurrencyMap = new Map()
        const apRealCurrencyMap = new Map()
        for (const row of this.dataProvider) {
          const currencyMap = row.ar ? arCurrencyMap : apCurrencyMap
          const currencyData = this.getDataFromCurrencyTotal(row.clearCurrencyAmount)
          for (const key in currencyData) {
            currencySet.add(key)
            let amount = currencyMap.get(key) || 0
            amount += currencyData[key]
            currencyMap.set(key, amount)
          }
          /* 应收实收金额、应付实付金额 */
          const realCurrencyMap = row.ar ? arRealCurrencyMap : apRealCurrencyMap
          currencySet.add(row.currency)
          let realAmount = realCurrencyMap.get(row.currency) || 0
          realAmount += row.verfiedAmount
          realCurrencyMap.set(row.currency, realAmount)
        }
        if (currencySet.size > 0) {
          this.columnDefs.push({
            headerName: this.$t('Billing.billingCharge_currency'),
            field: 'dispName',
            width: 130
          })
          this.rowData.push({ dispName: this.$t('WriteOff.ReceivableSoldAmount') })
          this.rowData.push({ dispName: this.$t('WriteOff.PayableSoldAmount') })
          this.rowData.push({ dispName: this.$t('WriteOff.ActualAmountReceivable') })
          this.rowData.push({ dispName: this.$t('WriteOff.ActualAmountPayable') })
          for (const currency of currencySet) {
            this.columnDefs.push({
              headerName: currency,
              field: currency,
              valueFormatter: params => {
                return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2, '0.00'))
              },
              width: 80
            })
            this.rowData[0][currency] = arCurrencyMap.get(currency) || 0
            this.rowData[1][currency] = apCurrencyMap.get(currency) || 0
            this.rowData[2][currency] = arRealCurrencyMap.get(currency) || 0
            this.rowData[3][currency] = apRealCurrencyMap.get(currency) || 0
          }
        }
      }
    },
    getDataFromCurrencyTotal(totalText) {
      const result = {}
      if (typeof totalText !== 'string') {
        return result
      }
      const items = totalText.split(';')
      for (const item of items) {
        if (!item) {
          continue
        }
        const strs = item.split(':')
        if (strs.length === 2) {
          result[strs[0]] = Number(strs[1]) || 0
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.actual-charge-sum-by-currency ::v-deep {
  position: relative;
  display: flex;
  justify-content: flex-start;
  .cargo-ag-grid {
    .ag-theme-balham {
      min-height: unset !important;
    }
  }
}
</style>
